import * as React from "react";

function Arrow({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 22" fill="none" {...props}>
      <path d="M10.376 1.676L1 10.853l9.393 9.195" fill="#" />
      <path
        d="M10.376 1.676L1 10.853l9.393 9.195"
        stroke={color}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Arrow;
